import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Output,
  QueryList,
  ViewChildren,
} from '@angular/core';
import { FormArray, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  EditableCustomServicesInputsComponent,
} from '../../editable-inputs/editable-custom-services-inputs/editable-custom-services-inputs.component';
import { SharedEditLocationSectionComponent } from '../shared-edit-location-section.component';
import { Store } from '@ngrx/store';
import { memoize } from '../../../../../core/decorators/memoize';
import { getFullNameForFieldID } from '../../../location-utils';
import { EditLocationLocalStore } from '../../edit-location-local-store.service';
import { SocialMediaUrl } from '../../../../../models/locations-models/social-media-urls';
import { LSCField } from '../../../../../models/LSCFields';
import { CustomServicesTControl } from '../../../../../models/locations-models/edit-location-form';
import { PushPipe } from '@ngrx/component';
import { TranslateModule } from '@ngx-translate/core';
import { MatButtonToggleGroup, MatButtonToggle } from '@angular/material/button-toggle';
import { MatButton } from '@angular/material/button';
import { MatDivider } from '@angular/material/divider';
import { MatTooltip } from '@angular/material/tooltip';
import { NgStyle, NgClass } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { EditableTextualInputComponent } from '../../editable-inputs/editable-textual-input/editable-textual-input.component';
import { IntersectionObserverDirective } from '../../../../../directives/general-intersection/intersection-observer.directive';

@Component({
    selector: 'app-other-information-section',
    templateUrl: './other-information.component.html',
    styleUrls: ['./other-information.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
        IntersectionObserverDirective,
        EditableTextualInputComponent,
        MatIcon,
        NgStyle,
        NgClass,
        MatTooltip,
        EditableCustomServicesInputsComponent,
        MatDivider,
        MatButton,
        FormsModule,
        ReactiveFormsModule,
        MatButtonToggleGroup,
        MatButtonToggle,
        TranslateModule,
        PushPipe,
    ],
})
export class OtherInformationSectionComponent extends SharedEditLocationSectionComponent {

  @Output() addCustomService: EventEmitter<void> = new EventEmitter<void>();
  @ViewChildren('serviceNameInputComponent') serviceNameInputComponents: QueryList<EditableCustomServicesInputsComponent>;

  // only show action buttons of the custom service container which is being hovered over
  formGroupNameWithVisibleButtons: number | null;

  nonStandardInputs = {
    customServices: { icon: 'format_list_bulleted', dataScrIconVisible: false },
    status: { icon: 'not_listed_location_outline', dataScrIconVisible: false },
  };
  nonStandardInputsKeys = Object.keys(this.nonStandardInputs);
  socialMediaUrl = SocialMediaUrl;

  constructor(protected store: Store, protected localStore: EditLocationLocalStore) {
    super(store, localStore);
  }

  get customServicesFormArray() {
    return this.getFormGroup().get(LSCField.customServices) as FormArray<FormGroup<CustomServicesTControl>>;
  }

  /**
   * Tell the parent to add a new custom service pair form control
   * and focus the last-added-group's `serviceName` input
   *
   */
  doAddCustomServicePair() {
    this.addCustomService.emit();
    // also, focus the last added group's native input
    // but wait a bit for the render of said last group to go thru
    setTimeout(() => {
      this.serviceNameInputComponents
          ?.last
          ?.serviceNameInput
          ?.nativeElement
          ?.focus({ preventScroll: true });
    }, 200);

  }

  /**
   * Tell the child with the matching formGroupName to show the actions buttons for
   */
  showActionButtons(targetIndex: number) {
    this.formGroupNameWithVisibleButtons = targetIndex;
  }

  @memoize()
  getFieldName(fieldId: string): string {
    return getFullNameForFieldID(fieldId);
  }

}
